import { dialogs } from 'svelte-dialogs';
export const presentConfirmationDialog = async (config) => {
    return await dialogs.confirm(Object.assign(Object.assign({}, config), { titleClass: 'dialog-title', confirmButtonClass: 'dialog-button dialog-confirmation-button', declineButtonClass: 'dialog-button dialog-decline-button', dialogClass: 'dialog__container dialog-surface' }));
};
